module.exports = __webpack_public_path__ + "img/good.429f6c62.svg";